module.exports = __webpack_public_path__ + "media/noclick.faf3eecb.mp3";